<template>
  <button class="button" :class="size" @click="$emit('click')">
    <!-- <Transition name="fade" mode="out-in"> -->
    <span :lastKey="text" class="button__text">
      {{ text }}
    </span>
    <!-- </Transition> -->
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      default: 'Texto por definir',
    },
    size: {
      type: String,
      default: 'md',
    },
    hoverTextColor: {
      type: String,
      default: 'white',
    },
    textColor: {
      type: String,
      default: 'white',
    },
    backgroundColor: {
      type: String,
      default: 'black',
    },
    hoverBackgroundColor: {
      type: String,
      default: 'rgb(black, 0.5)',
    },
    borderRadius: {
      type: String,
      default: '0px',
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  cursor: pointer;
  border: none;
  outline: none;
  width: auto;
  height: 20px;
  padding: 0px 15px;
  border-radius: v-bind(borderRadius);
  background-color: v-bind(backgroundColor);
  -webkit-transition: 0.35s ease-in-out all;
  -moz-transition: 0.35s ease-in-out all;
  -ms-transition: 0.35s ease-in-out all;
  -o-transition: 0.35s ease-in-out all;
  transition: 0.35s ease-in-out all;
  &__text {
    font-size: 13px;
    font-weight: inherit;
    color: v-bind(textColor);
    white-space: nowrap;
    -webkit-transition: 0.35s ease-in-out all;
    -moz-transition: 0.35s ease-in-out all;
    -ms-transition: 0.35s ease-in-out all;
    -o-transition: 0.35s ease-in-out all;
    transition: 0.35s ease-in-out all;
  }
  @media (hover: hover) {
    &:hover {
      background-color: v-bind(hoverBackgroundColor);
      -webkit-transition: 0.35s ease-in-out all;
      -moz-transition: 0.35s ease-in-out all;
      -ms-transition: 0.35s ease-in-out all;
      -o-transition: 0.35s ease-in-out all;
      transition: 0.35s ease-in-out all;
      & .button {
        &__text {
          color: v-bind(hoverTextColor);
          -webkit-transition: 0.35s ease-in-out all;
          -moz-transition: 0.35s ease-in-out all;
          -ms-transition: 0.35s ease-in-out all;
          -o-transition: 0.35s ease-in-out all;
          transition: 0.35s ease-in-out all;
        }
      }
    }
  }
  &.sm {
    height: 10px;
  }
  &.lg {
    height: 30px;
  }
}
</style>
